export default class GuideDependent {
  constructor(
    name = "",
    gender = "",
    birthDate = null,
    city = "",
    cpf = ""
  ) {
    this.name = name;
    this.gender = gender;
    this.birthDate = birthDate;
    this.city = city;
    this.cpf = cpf;
  }
}



// WEBPACK FOOTER //
// ./src/model/GuideDependent.js